// Gate for the Pay and Services tabs (§3): only a customer whose account is
// active and who has set up mobile banking can use them. Everyone else sees
// the "Set up mobile banking first" prompt. When account data simply isn't
// available (offline dev), the gate does not block.
import { useEffect, useState, type ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileScreen } from '@fortawesome/free-solid-svg-icons';
import type { RootState } from '@/store';
import { loadDb } from '@/mock/db';
import Button from '@/components/ui/Button/Button';

const MobileBankingGate = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const { accounts, loading } = useSelector((state: RootState) => state.account);
  const [mobileBanking, setMobileBanking] = useState(true);

  useEffect(() => {
    setMobileBanking(loadDb().limits.mobileBanking);
  }, []);

  const accountCheck =
    accounts.length === 0 || accounts.some((a) => a.status === 'ACTIVE');
  const blocked = !mobileBanking || (!loading && !accountCheck);

  if (blocked) {
    return (
      <div className="nova-gate">
        <FontAwesomeIcon icon={faMobileScreen} size="3x" className="nova-gate-icon" />
        <p>Set up mobile banking first</p>
        <Button onClick={() => navigate('/register')}>Set up</Button>
      </div>
    );
  }
  return <>{children}</>;
};

export default MobileBankingGate;
